import { Auth } from 'aws-amplify'
import React, { useCallback, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { ToastStyle } from '../Data/MovieStaticData'
import { useHistory } from 'react-router-dom'
import UpdateMoviePublished from '../../Services/Mutations/UpdateMoviePublished'
import Updatepersonstatus from '../../Services/Mutations/updatepersonstatus'

const ApproveCreateMoviePerson = ({
  loadPopup,
  setLoadPopup,
  moviePerson,
  movieData,
  sendTFIDBPN,
}) => {
  const history = useHistory()
  const [isButtonClicked, setIsButtonClicked] = useState(false)
  // const [sendTFIDBPN, setSendTFIDBPN] = useState(false)

  const getLoggedInUserHandle = useCallback(() => {
    const loggedInUserEmail = Auth.user.attributes?.email || ''
    return loggedInUserEmail ? `@${loggedInUserEmail.split('@')[0]}` : ''
  }, [])
  const redirectToEditPage = () => {
    const editPath = moviePerson === 'person' ? '/editperson' : '/editmovie'
    history.push(`${editPath}?${encodeURI(movieData.PK)}`)
    window.location.reload(false)
  }

  const handleApprovalSuccess = useCallback(
    statusMessage => {
      toast.success(statusMessage, ToastStyle)
      setTimeout(() => redirectToEditPage(), 3000)
    },
    [moviePerson, movieData, history],
  )

  const cancelApproval = () => {
    setLoadPopup(false)
    redirectToEditPage()
  }

  const approveMovie = async () => {
    setIsButtonClicked(true)
    const loggedInUserHandle = getLoggedInUserHandle()

    const publishedListUpdate = {
      status: 'published',
      PK: movieData.PK,
      SK: movieData.SK,
      moderatorID: Auth.user.username,
      moderatorHandle: loggedInUserHandle,
      ...((moviePerson === 'movie' || moviePerson === 'webseries') &&
        sendTFIDBPN && { sendTFIDBPN: true }),
    }

    try {
      let update

      if (moviePerson === 'movie' || moviePerson === 'webseries') {
        update = await UpdateMoviePublished(publishedListUpdate)
      } else if (moviePerson === 'person') {
        update = await Updatepersonstatus({
          PK: movieData.PK,
          SK: movieData.SK,
          status: 'published',
        })
      }

      const { statusCode, statusMessage } = update.data?.updateMovieStatus || update
      const approvedStatusCodes = ['A367', 'A368', 'A371']

      if (approvedStatusCodes.includes(statusCode)) {
        handleApprovalSuccess(statusMessage)
      }
    } catch (error) {
      console.error('Error during approval:', error)
    }
  }

  return (
    <>
      <Modal show={loadPopup} dialogClassName='modal-90w' onHide={() => setLoadPopup(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Approve</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {`Are you sure to approve this ${moviePerson}`}
          {/* {(moviePerson === 'movie' || moviePerson === 'webseries') && (
            <div className='form-check mt-3'>
              <input
                className='form-check-input'
                type='checkbox'
                id='sendTFIDBPN'
                checked={sendTFIDBPN}
                onChange={() => setSendTFIDBPN(!sendTFIDBPN)}
              />
              <label className='form-check-label' htmlFor='sendTFIDBPN'>
                send Notification
              </label>
            </div>
          )} */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={cancelApproval}>
            Close
          </Button>
          <Button variant='primary' onClick={approveMovie} disabled={isButtonClicked}>
            {isButtonClicked ? 'Approving...' : 'Approve'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ApproveCreateMoviePerson
